/** Відбір без швидких полів — база лічильника «N з M» (прототип v4 fbCount). Чиста функція. */

/** Фільтр-DSL без умов `part` (умови швидких полів у тому самому порядку, що їх додає useAdvancedDsl); без збігу — фільтр як є. */
export function withoutPart(filter: string | undefined, part: string): string {
  const all = (filter ?? '').split(';').filter(Boolean);
  const drop = part.split(';').filter(Boolean);
  if (!drop.length) return all.join(';');
  for (let i = 0; i + drop.length <= all.length; i += 1) {
    if (drop.every((d, j) => all[i + j] === d)) return [...all.slice(0, i), ...all.slice(i + drop.length)].join(';');
  }
  return all.join(';');
}
